import { ValidationService } from '../../services/validation.service';

export class CancelReport {

  reportID: string = '';

  confirmationNumber: string = 'Incomplete';

  emailedAt: string = ''; // written by the backend when the report email is actually sent; suppresses duplicate sends

  completionDate: Date = new Date(); // not currently used, but app will eventually populate dynamically

  submissionDate: Date = new Date(); // date the report was submitted to DFO (only accurate if 'isSubmitted'=true)

  comments: string = '';

  /* Flags for programmatical use */

  isComplete: boolean = false; // date the report was completed within the app

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  constructor() {

  }

  public toString(): string {
    return 'Cancel Date: ' + this.completionDate + '; Confirmation Number: ' + this.confirmationNumber;
  }

  // check if the user's Cancel Fishing Report is defined
  public static transformAnonymous(cancelReport: any): CancelReport {

    // if it is not defined, set a new one
    if (!cancelReport) {
      return new CancelReport();
    }

    let userCancelReport: CancelReport = new CancelReport();
    userCancelReport.confirmationNumber = cancelReport.confirmationNumber ?? '';
    userCancelReport.emailedAt = cancelReport.emailedAt ?? '';
    userCancelReport.completionDate = ValidationService.validateDate(cancelReport.completionDate);
    userCancelReport.submissionDate = ValidationService.validateDate(cancelReport.submissionDate);
    userCancelReport.comments = cancelReport.comments ?? '';
    userCancelReport.reportID = cancelReport.reportID;
    userCancelReport.isComplete = cancelReport.isComplete ?? false;
    userCancelReport.isSubmitted = cancelReport.isSubmitted ?? false;
    return userCancelReport;

  }
}
